"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var use_locale_hook_1 = __importDefault(require("../../../context/locale/use-locale.hook"));
var styled_components_1 = __importDefault(require("styled-components"));
var dash_component_1 = __importDefault(require("./dash.component"));
var mobile_component_1 = __importDefault(require("../../responsive/mobile.component"));
var desktop_component_1 = __importDefault(require("../../responsive/desktop.component"));
var dash_mobile_component_1 = __importDefault(require("./dash-mobile.component"));
var LevelSettingContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  font-size: 10px;\n  color: ", ";\n  align-items: center;\n  height: 16px;\n"], ["\n  display: flex;\n  font-size: 10px;\n  color: ", ";\n  align-items: center;\n  height: 16px;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.installationSketch.color;
});
var Value = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  margin: ", ";\n"], ["\n  font-weight: bold;\n  margin: ", ";\n"])), function (_a) {
    var side = _a.side;
    return "0 " + (side === 'right' ? '4px' : '0') + " 0 " + (side === 'left' ? '4px' : '0px');
});
var getFlexDirection = function (orientation, side) {
    if (orientation === 'vertical') {
        return 'column';
    }
    return side === 'right' ? 'row-reverse' : 'row';
};
var ValueContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n"])), function (_a) {
    var orientation = _a.orientation, side = _a.side;
    return getFlexDirection(orientation, side);
}, function (_a) {
    var orientation = _a.orientation, side = _a.side;
    return (orientation === 'vertical' && side === 'left' ? 'flex-end' : 'initial');
});
var LevelSetting = function (_a) {
    var text = _a.text, value = _a.value, _b = _a.side, side = _b === void 0 ? 'left' : _b, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c, offset = _a.offset, unit = _a.unit, _d = _a.hideValue, hideValue = _d === void 0 ? false : _d, _e = _a.showCircle, showCircle = _e === void 0 ? false : _e, testID = _a.testID;
    var formatWithDigits = use_locale_hook_1.default().formatWithDigits;
    var formattedValue = formatWithDigits(value, 2) + " " + (unit || '');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(mobile_component_1.default, null,
            react_1.default.createElement(LevelSettingContainer, null,
                react_1.default.createElement(dash_mobile_component_1.default, { side: side }))),
        react_1.default.createElement(desktop_component_1.default, null,
            react_1.default.createElement(LevelSettingContainer, { "data-test-id": testID },
                side === 'right' && react_1.default.createElement(dash_component_1.default, { side: side, offset: offset, showCircle: showCircle }),
                react_1.default.createElement(ValueContainer, { orientation: orientation, side: side },
                    react_1.default.createElement("span", null, text),
                    !hideValue && (react_1.default.createElement(Value, { "data-test-id": text, side: side }, formattedValue))),
                side === 'left' && react_1.default.createElement(dash_component_1.default, { side: side, offset: offset, showCircle: showCircle })))));
};
LevelSetting.displayName = 'LevelSetting';
exports.default = LevelSetting;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=installation-level-setting.component.js.map